export enum TipoRetornoRequisicaoDeRetorno {
  LISTA_OPCOES = 'Lista de Opções',
  MENSAGEM = 'Mensagem',
  ARQUIVO = 'Arquivo',
}
